"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExceptionMap = exports.IconMap = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var config_provider_1 = require("../config-provider");
var PromptCheckCircleFill_1 = require("../Icons/PromptCheckCircleFill");
var PromptCloseCircleFill_1 = require("../Icons/PromptCloseCircleFill");
var PromptInfoCircleFill_1 = require("../Icons/PromptInfoCircleFill");
var PromptWarningCircleFill_1 = require("../Icons/PromptWarningCircleFill");
var empty_1 = tslib_1.__importDefault(require("./empty"));
var end_1 = tslib_1.__importDefault(require("./end"));
var noFound_1 = tslib_1.__importDefault(require("./noFound"));
var noPermission_1 = tslib_1.__importDefault(require("./noPermission"));
var serverError_1 = tslib_1.__importDefault(require("./serverError"));
var unauthorized_1 = tslib_1.__importDefault(require("./unauthorized"));
exports.IconMap = {
    success: PromptCheckCircleFill_1.PromptCheckCircleFill,
    error: PromptCloseCircleFill_1.PromptCloseCircleFill,
    info: PromptInfoCircleFill_1.PromptInfoCircleFill,
    warning: PromptWarningCircleFill_1.PromptWarningCircleFill,
};
exports.ExceptionMap = {
    '404': noFound_1.default,
    '500': serverError_1.default,
    '403': unauthorized_1.default,
    'empty': empty_1.default,
    'end': end_1.default,
    'author': noPermission_1.default,
};
// ExceptionImageMap keys
var ExceptionStatus = Object.keys(exports.ExceptionMap);
/**
 * Render icon if ExceptionStatus includes ,render svg image else render iconNode
 *
 * @param prefixCls
 * @param {status, icon}
 */
var renderIcon = function (prefixCls, _a) {
    var status = _a.status, icon = _a.icon;
    var className = (0, classnames_1.default)("".concat(prefixCls, "-icon"));
    if (ExceptionStatus.includes("".concat(status))) {
        var SVGComponent = exports.ExceptionMap[status];
        return (React.createElement("div", { className: "".concat(className, " ").concat(prefixCls, "-image") },
            React.createElement(SVGComponent, null)));
    }
    var iconNode = React.createElement(exports.IconMap[status]);
    return React.createElement("div", { className: className }, icon || iconNode);
};
var renderExtra = function (prefixCls, _a) {
    var extra = _a.extra;
    return extra && React.createElement("div", { className: "".concat(prefixCls, "-extra") }, extra);
};
var Result = function (_a) {
    var _b;
    var customizePrefixCls = _a.prefixCls, customizeClassName = _a.className, subTitle = _a.subTitle, title = _a.title, style = _a.style, children = _a.children, _c = _a.status, status = _c === void 0 ? 'info' : _c, icon = _a.icon, extra = _a.extra;
    var _d = React.useContext(config_provider_1.ConfigContext), getPrefixCls = _d.getPrefixCls, direction = _d.direction;
    var prefixCls = getPrefixCls('result', customizePrefixCls);
    var className = (0, classnames_1.default)(prefixCls, "".concat(prefixCls, "-").concat(status), customizeClassName, (_b = {},
        _b["".concat(prefixCls, "-rtl")] = direction === 'rtl',
        _b));
    return (React.createElement("div", { className: className, style: style },
        renderIcon(prefixCls, { status: status, icon: icon }),
        React.createElement("div", { className: "".concat(prefixCls, "-title") }, title),
        subTitle && (React.createElement("div", { className: "".concat(prefixCls, "-subtitle") },
            React.createElement("div", { className: "".concat(prefixCls, "-subtitle-width") }, subTitle))),
        renderExtra(prefixCls, { extra: extra }),
        children && React.createElement("div", { className: "".concat(prefixCls, "-content") }, children)));
};
Result.PRESENTED_IMAGE_403 = exports.ExceptionMap['403'];
Result.PRESENTED_IMAGE_404 = exports.ExceptionMap['404'];
Result.PRESENTED_IMAGE_500 = exports.ExceptionMap['500'];
Result.PRESENTED_IMAGE_EMPTY = exports.ExceptionMap.empty;
Result.PRESENTED_IMAGE_END = exports.ExceptionMap.end;
Result.PRESENTED_IMAGE_AUTHOR = exports.ExceptionMap.author;
exports.default = Result;
//# sourceMappingURL=index.js.map